// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b_4Y4","top":"styles_top__6ILoh"};